// import RotatingGlobeEmoji from "./RotatingGlobeEmoji";
import dynamic from "next/dynamic";
import Image from "next/legacy/image";

// import { useEffect, useState } from "react";
// import { useAccount } from "wagmi";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

// import { useFarcaster } from "../hooks/useFarcasterUser";
import FarcasterFollowingLeaderboard from "./FarcasterFollowingLeaderboard";
import Leaderboard, { RankData } from "./Leaderboard";
import LeagueLeaderboard from "./LeagueLeaderboard";

const RotatingGlobeEmoji = dynamic(() => import("./RotatingGlobeEmoji"));
const LEAGUES = [
  //   {
  //     collection_id: "8a053333e45288f76bb5d1d9173bb50b",
  //     name: "Based Ghouls",
  //     description: null,
  //     image_url:
  //       "https://lh3.googleusercontent.com/rjqeiHMOX285jirPJIYX-68AoeYAwFz_VPm-V7Ib5tLWx0yw6D3pJeIsbJEe_pwANrMUuGDeBAprddHKfi27MfJdMaGii2WLFYs",
  //   },
];
const LeaderboardSelector = ({
  seed,
  updatedAt,
  leaders,
}: {
  seed: string;
  updatedAt: bigint;
  leaders: RankData[];
}) => {
  // const { address } = useAccount();
  // const [preferred, _setPreferred] = useState("global");
  // const {
  //   isLoading,
  //   data: { fid },
  //   error,
  // } = useFarcaster({ address });

  // useEffect(() => {
  //   const pref = window.localStorage.getItem("leaderboard");
  //   _setPreferred(pref || "global");
  // }, [address]);

  // const setPreffered = (value: string) => {
  //   window.localStorage.setItem("leaderboard", value);
  //   _setPreferred(value);
  // };

  // if (isLoading)
  //   return <p className="text-center text-gray-500">[Loading...]</p>;

  // if (!fid) {
  //   return <Leaderboard seed={seed} updatedAt={updatedAt} />;
  // }

  return (
    <Tabs
      // key={fid}
      defaultValue={"global"}
      // onValueChange={(value) => setPreffered(value)}
      className="w-full m-auto max-w-1/3 overflow-scroll"
    >
      <div className="flex justify-center w-full  text-lg">
        <TabsList className="h-12">
          <TabsTrigger className="text-xl px-3 py-1" value="global">
            <RotatingGlobeEmoji /> Global
          </TabsTrigger>
          <TabsTrigger
            className="text-xl px-3 py-1 flex flex-row items-center"
            value="following"
          >
            <i className="fc fc-farcaster text-[#8963D2] mr-1 mb-1 h-full"></i>{" "}
            <span>Following</span>
          </TabsTrigger>

          {LEAGUES.map((league) => (
            <TabsTrigger
              key={league.collection_id}
              className="text-xl px-3 py-1"
              value={league.collection_id}
            >
              <Image
                alt="League icon"
                className="mr-4 mb-1"
                width="24"
                height="24"
                src={league.image_url}
              />
              <span>{league.name}</span>
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
      <TabsContent value="global">
        <Leaderboard seed={seed} initialData={leaders} />
      </TabsContent>
      <TabsContent value="following">
        <FarcasterFollowingLeaderboard seed={seed} updatedAt={updatedAt} />
      </TabsContent>
      {/* {LEAGUES.map((league) => (
        <TabsContent key={league.collection_id} value={league.collection_id}>
          <LeagueLeaderboard seed={seed} league={league.collection_id} />
        </TabsContent>
      ))} */}
    </Tabs>
  );
};

export default LeaderboardSelector;
